export default __webpack_public_path__ + "static/media/d.27635e13.png";